import React from 'react';
import ReactDOM from 'react-dom';
import WebFont from 'webfontloader';
import './css/index.css';
import MainApp from './MainApp';

WebFont.load({
  google: {
    families: ['Material Icons', 'poppins']
  }
});

ReactDOM.render( <MainApp /> , document.getElementById('root'));
//registerServiceWorker();
